/**
 * ManageVPE Page Wrapper
 * Handles navigation for VPE management page
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import ManageVPE from '@/components/ea/ManageVPE';

export const ManageVPEPageWrapper: React.FC = () => {
  const navigate = useNavigate();

  // Handle back navigation - return to dashboard
  const handleBack = () => {
    navigate('/dashboard');
  };

  return (
    <ManageVPE onBack={handleBack} />
  );
};

export default ManageVPEPageWrapper;